
import './App.css';
import { Header } from './Components/Header/Header';

import { MainRoutes } from './MainRoutes/Routes';

function App() {
  return (
    <>   
    <Header/>
    <MainRoutes/>
    <div className="App">
      
    </div>
    
    </>
  );
}

export default App;
